import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type PageLayoutProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

export function PageLayout({ children, className = '', contentClassName = '' }: PageLayoutProps) {
  return (
    <main className={cn('flex flex-1 flex-col bg-background px-6 py-8 text-foreground', className)}>
      <div className={cn('mx-auto flex w-full max-w-6xl flex-col space-y-6', contentClassName)}>
        {children}
      </div>
    </main>
  );
}
